import { Box, Card, CardContent, Stack, Typography } from '@mui/material';

interface ReportStatsProps {
	title: string;
	value: string;
	sx?: any;
}

export const ReportStats = (props: ReportStatsProps) => {
	const { title, value, sx } = props;

	return (
		<Card sx={sx}>
			<CardContent>
				<Stack
					alignItems="flex-start"
					direction="row"
					justifyContent="space-between"
					spacing={3}
				>
					<Stack spacing={1}>
						<Typography
							color="text.secondary"
							variant="overline"
						>
							{title}
						</Typography>
						<Typography variant="h4">
							{value}
						</Typography>
					</Stack>
				</Stack>
			</CardContent>
		</Card>
	);
};